// Fase 1 (ClientContacts): enquanto false, a Carteira de Clientes nao oferece
// edicao de celular nem "Vincular a contato existente". Mudar para true para ligar.
export const FASE1_CLIENT_CONTACTS_ENABLED = false;
